/**
 * Centralized query keys for TanStack Query
 * Ensures consistency and type safety across the app
 */

export const queryKeys = {
  // Journeys
  journeys: ['journeys'] as const,
  journey: (id: string) => ['journeys', id] as const,

  // Checklists
  checklists: ['checklists'] as const,
  checklist: (journeyId: string) => ['checklists', journeyId] as const,

  // Clinics
  clinics: ['clinics'] as const,
  clinic: (id: string) => ['clinics', id] as const,

  // Advisor
  advisor: ['advisor'] as const,
  messages: ['messages'] as const,

  // Notifications
  notifications: ['notifications'] as const,

  // Suggestions
  suggestions: ['suggestions'] as const,

  // User profile
  profile: ['profile'] as const,
} as const;
